import AsyncStorage from '@react-native-async-storage/async-storage';
import { STORAGE_KEYS } from 'shared/constants/storage';

// TODO: JT-151061 This function will be removed, need to align with Charlie for the initialization refactor.
export async function isUserAuthenticated(): Promise<boolean> {
  try {
    const refreshToken = await AsyncStorage.getItem(STORAGE_KEYS.REFRESH_TOKEN);
    return Boolean(refreshToken);
  } catch {
    return false;
  }
}
